import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { solicitarAcceso } from "../Login/Users-Api";
import { ToastContainer, toast } from "react-toastify";
import { isEmpty } from "../../util/Functions";

const IaxAccessRequest = ({ open, onClose, onAccept }) => {
  const [email, setEmail] = useState("");
  const [aceptardisabled, setAceptardisabled] = useState(false);

  useEffect(() => {
    setEmail("");
  }, []);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleAccept = () => {    
    if (!isEmpty(email)) {
      setAceptardisabled(true);
      solicitarAcceso(email, onAccept);
      setAceptardisabled(false);
      setEmail("");
    }    
  };

  const handleCancel = () => {
    // Cerrar el diálogo sin realizar ninguna acción
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Introduzca su correo electrónico @murciaeduca.es
      </DialogTitle>
      <DialogContent>
        <TextField
          label="email"
          variant="outlined"
          fullWidth
          value={email}
          onChange={handleEmailChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Cancelar
        </Button>
        <Button disabled={aceptardisabled} onClick={handleAccept} color="primary" variant="contained">
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IaxAccessRequest;
